module.exports = __webpack_public_path__ + "static/img/5.315c1223.png";